export default "__VITE_ASSET__e1e7dc90__"